export default __webpack_public_path__ + "static/media/Atendimento (Real Size).dc459710.svg";